(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-project-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * "Print this guide". A button rather than a link, because it performs an
   * action rather than navigating; hidden from the printed sheet itself.
   */
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-dm-print]')) window.print();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-project-index"] && !Shopify.designMode) return;
  try {
    
  /**
   * Client-side facets for the project library.
   *
   * Filtering hides cards rather than rebuilding the grid, and sorting sets the
   * CSS `order` property rather than moving nodes, so nothing is ever removed
   * from the accessibility tree mid-interaction and focus is never lost.
   */
  if (!customElements.get('dm-project-index')) {
    class DmProjectIndex extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-dm-filters]');
        this.grid = this.querySelector('[data-dm-grid]');
        this.counter = this.querySelector('[data-dm-count]');
        this.emptyState = this.querySelector('[data-dm-empty]');
        this.filterDisclosure = this.querySelector('[data-dm-filter-disclosure]');
        this.cards = Array.from(this.querySelectorAll('[data-dm-project]'));
        this.total = Number(this.dataset.total) || this.cards.length;
        if (!this.form || !this.cards.length) return;

        this.apply = this.apply.bind(this);
        this.syncFilterDisclosure = this.syncFilterDisclosure.bind(this);
        this.desktopFilters = window.matchMedia('(min-width: 750px)');
        this.syncFilterDisclosure();
        this.desktopFilters.addEventListener('change', this.syncFilterDisclosure);
        this.form.addEventListener('input', this.apply);
        this.form.addEventListener('change', this.apply);
        this.form.addEventListener('submit', (event) => event.preventDefault());
        this.form.addEventListener('reset', () => window.requestAnimationFrame(this.apply));
        this.apply();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('input', this.apply);
        this.form?.removeEventListener('change', this.apply);
        this.desktopFilters?.removeEventListener('change', this.syncFilterDisclosure);
      }

      syncFilterDisclosure() {
        if (this.filterDisclosure) this.filterDisclosure.open = this.desktopFilters.matches;
      }

      checked(name) {
        return Array.from(this.form.querySelectorAll(`input[name="${name}"]:checked`), (input) => input.value);
      }

      apply() {
        const categories = this.checked('category');
        const levels = this.checked('difficulty');
        const formats = this.checked('format');
        const type = (this.form.elements.type?.value || '').trim();
        const wood = (this.form.elements.wood?.value || '').trim();
        const query = (this.form.elements.q?.value || '').trim().toLowerCase();
        const sort = this.form.elements.sort?.value || 'default';

        const matched = [];

        this.cards.forEach((card, index) => {
          const data = card.dataset;
          const visible =
            (!categories.length || categories.includes(data.category)) &&
            (!levels.length || levels.includes(data.difficulty)) &&
            (!formats.length || formats.includes(data.format)) &&
            (!type || data.type === type) &&
            (!wood || (data.wood || '').includes(`|${wood}|`)) &&
            (!query || (data.search || '').includes(query));

          card.hidden = !visible;
          card.style.order = String(index);
          if (visible) matched.push(card);
        });

        if (sort === 'az') {
          matched.sort((a, b) => (a.dataset.title || '').localeCompare(b.dataset.title || ''));
        } else if (sort === 'steps') {
          matched.sort((a, b) => Number(b.dataset.steps || 0) - Number(a.dataset.steps || 0));
        }

        if (sort !== 'default') {
          matched.forEach((card, position) => {
            card.style.order = String(position);
          });
        }

        if (this.counter) {
          this.counter.textContent =
            matched.length === this.total
              ? `${this.total} projects`
              : `${matched.length} of ${this.total} projects`;
        }

        if (this.emptyState) this.emptyState.hidden = matched.length > 0;
      }
    }

    customElements.define('dm-project-index', DmProjectIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-project-steps"] && !Shopify.designMode) return;
  try {
    
  /**
   * The in-page step navigator.
   *
   * Marks the step you are reading, keeps a "4 / 13" counter and a progress
   * rule in sync, opens itself as a rail on desktop and collapses back to a
   * disclosure on a phone. All of it is additive: the markup is a plain
   * `<details>` with anchor links and works without this file.
   */
  if (!customElements.get('dm-project-nav')) {
    class DmProjectNav extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.dm-project-nav__panel');
        this.counter = this.querySelector('[data-dm-nav-current]');
        this.links = Array.from(this.querySelectorAll('[data-dm-nav-link]'));
        this.total = Number(this.dataset.total) || this.links.length || 1;
        this.visible = new Set();
        this.active = null;

        this.desktop = window.matchMedia('(min-width: 1100px)');
        this.syncOpen = this.syncOpen.bind(this);
        this.onClick = this.onClick.bind(this);
        this.syncOpen();
        this.desktop.addEventListener('change', this.syncOpen);
        this.addEventListener('click', this.onClick);

        const steps = Array.from(document.querySelectorAll('[data-dm-step]'));
        if (!steps.length) return;

        // A narrow band across the upper third of the viewport: whatever sits
        // in it is what the reader is actually looking at.
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              const step = entry.target.dataset.dmStep;
              if (entry.isIntersecting) this.visible.add(step);
              else this.visible.delete(step);
            }
            if (this.visible.size) {
              const first = Math.min(...Array.from(this.visible, Number));
              this.setActive(String(first));
            }
          },
          { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
        );

        for (const step of steps) this.observer.observe(step);
        this.setActive(steps[0].dataset.dmStep);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.desktop?.removeEventListener('change', this.syncOpen);
        this.removeEventListener('click', this.onClick);
      }

      syncOpen() {
        if (this.details) this.details.open = this.desktop.matches;
        if (this.summary) {
          if (this.desktop.matches) this.summary.setAttribute('tabindex', '-1');
          else this.summary.removeAttribute('tabindex');
        }
      }

      onClick(event) {
        if (this.desktop.matches && event.target.closest('summary')) {
          event.preventDefault();
          return;
        }

        const link = event.target.closest('[data-dm-nav-link]');
        if (link && this.details && !this.desktop.matches) this.details.open = false;
      }

      setActive(step) {
        if (!step || step === this.active) return;
        this.active = step;

        let activeLink = null;
        for (const link of this.links) {
          if (link.dataset.dmNavLink === step) {
            link.setAttribute('aria-current', 'true');
            activeLink = link;
          } else {
            link.removeAttribute('aria-current');
          }
        }

        if (this.counter) this.counter.textContent = step;
        this.style.setProperty('--dm-project-nav-progress', String(Number(step) / this.total));

        // Scroll the rail itself, never the page.
        if (this.panel && activeLink && this.panel.scrollHeight > this.panel.clientHeight) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.panel.scrollTo({
            top: activeLink.offsetTop - this.panel.clientHeight / 2 + activeLink.offsetHeight / 2,
            behavior: reduce ? 'auto' : 'smooth',
          });
        }
      }
    }

    customElements.define('dm-project-nav', DmProjectNav);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
